<section class="users-view">
    <!-- Media object starts -->
    <div class="row">
      <div class="col-12 col-sm-7">
        <div class="media d-flex align-items-center">
         
         <div *ngIf="attendanceData?.image">
            <img class="users-avatar-shadow rounded mr-1" [src]="attendanceData?.image"
              height="64" width="64" alt="datatable-avatar">
          </div>
          
            <div *ngIf="!attendanceData?.image" [class.initial-alpha]="!attendanceData?.image" class="users-avatar-shadow rounded mr-1 ml-0" >
              <div class="avatar-content">{{ attendanceData?.user.name | shortName }}</div>
            </div>
          <div class="media-body ml-3">
            <h4>
              <span class="users-view-name mr-1">{{ attendanceData?.user.name }}</span>
            
            </h4>  
            <span class="mr-1">ID:</span>
            <span class="users-view-id">{{
              attendanceData?._id.substring(attendanceData?._id.length - 6)
            }}</span>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-5 d-flex justify-content-end align-items-center">
        <!-- <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary mr-2
          px-3 py-1"><i class="ft-mail"></i></a>
        <a href="javaScript:void(0);" class="btn btn-sm bg-light-secondary mr-2
          px-3 py-1">Profile</a> -->
        <a
          [routerLink]="['/categories/category-edit', attendanceData?._id]"
          class="btn btn-sm btn-primary px-3 py-1"
          >Edit</a
        >
      </div>
    </div>
    <!-- Media object ends -->
  
    <div class="row">
      <div class="col-12">
        <!-- Card data starts -->
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-xl-4">
                  <table class="table table-borderless">
                    <tbody>
                      <tr>
                        <td>Name</td>
                        <td>{{ attendanceData?.user.name }}</td>
                      </tr>
                      <tr>
                        <td> Attendance Date</td>
                        <td >{{attendanceData?.attendanceDate | date: "mediumDate"}}</td>
                      </tr>
                      <tr>
                        <td>startTime</td>
                        <td>{{ attendanceData?.startTime }}</td>
                      </tr>
                      <tr>
                        <td>endTime</td>
                        <td >{{ attendanceData?.endTime }}</td>
                      </tr>
                     
                      
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Card data ends -->
      </div>
      <div class="col-12"> 
        
      <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                        <tr>
                            <td>Verified</td>
                            <td>{{ attendanceData?.isVerified }}</td>
                          </tr>
                      <tr>
                        <tr>
                            <td>Working Hours:</td>
                            <td>{{ attendanceData?.workingHours  }}</td>
                          </tr>
                      <tr>
                        <td>Registered:</td>
                        <td>{{ attendanceData?.createdOn | date: "mediumDate" }}</td>
                      </tr>
                      <tr>
                        <td>Latest Activity:</td>
                        <td >
                          {{ attendanceData?.updatedOn | date: "mediumDate" }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> 
      </div>
      <!-- <div class="col-12"> -->
        <!-- User detail starts -->
        <!-- <div class="card">
          <div class="card-content">
            <div class="card-body">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table table-borderless">
                    <tbody>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      <!-- </div> -->
      <!-- User detail ends -->
    </div>
  </section>
  
